// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'distribute-item-vert-center-solid';

export const Component = () => (
  <path d='M4.406 7.89h15.709c.431 0 .766.144 1.054.432.287.287.431.623.431 1.054v5.843c0 .431-.144.766-.431 1.054a1.408 1.408 0 0 1-1.054.43H4.406a1.41 1.41 0 0 1-1.054-.43 1.408 1.408 0 0 1-.43-1.054V9.376c0-.431.143-.767.43-1.054a1.408 1.408 0 0 1 1.054-.431ZM.48 2.959h23.563c.335 0 .48-.144.48-.48 0-.334-.145-.478-.48-.478H.48C.144 2 0 2.144 0 2.479c0 .335.144.479.479.479Zm23.563 18.678H.48c-.335 0-.479.144-.479.479 0 .335.144.479.479.479h23.563c.335 0 .48-.144.48-.48 0-.334-.145-.478-.48-.478Z' />
);

export const viewBox = '0 0 25 25';
